function getAPIHost() {
  const { host } = window.location;
  const hostParts = host.split('.');
  hostParts.splice(1, 0, 'api');
  return hostParts.join('.');
}

module.exports = getAPIHost;
